import type { ErgonomicPhotoKind } from '../../../../../types/ergonomicWorkstation';

/** Os limites do modelo (1 de abertura, 8 de registro), usados enquanto `/options` ainda não chegou. */
export const DEFAULT_PHOTO_LIMITS: Record<ErgonomicPhotoKind, number> = { ABERTURA: 1, REGISTRO: 8 };
